<div class="modal-content drips-modal" [ngClass]="brandInfo.brand.toLowerCase()">
  <div class="modal-header mb-n1">
    <span aria-hidden="true">
      <mdb-icon id="closeDripsModalIcon" tabindex="0" class="modal-close-icon" aria-label="Close" (click)="modalRef.hide()" fas
      icon="times"></mdb-icon>
    </span>
  </div>
  @if (!showSuccessMessage) {
    <div class="modal-body">
      <div class="row">
        <div class="col-12">
          <h3 class="mb-2">{{this.branding.drips_title}}</h3>
          <p class="mb-4" [innerHTML]="this.branding.drips_text | safeHtml"></p>
        </div>
      </div>
      <form [formGroup]="form">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6">
            <label for="phoneNumber">{{ 'CART_CHECKOUT.PHONE_NUMBER' | translate }}</label>
            <input type="text" id="phoneNumber" class="form-control" mdbInput mdbValidate formControlName="phone" />
            @if (form.controls.phone.invalid && (form.controls.phone.dirty || form.controls.phone.touched)) {
              <mdb-error role="alert"> *{{ 'CART_CHECKOUT.PHONE_NUMBER_REQ' | translate }} </mdb-error>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6 pb-2 pt-2">
            <a id="sendDripsMessageButton" class="btn primary-btn drips waves-light uppercase" mdbBtn mdbWavesEffect (click)="sendMessage()">{{ this.branding.drips_button }}</a>
          </div>
        </div>
        <div class="row mobile pb-5"></div>
      </form>
    </div>
  }
  @if (showSuccessMessage) {
    <div class="modal-body">
      <div class="row">
        <div class="col-12">
          <h3 class="mb-2" [innerHTML]="this.branding.submitted_title | safeHtml"></h3>
          <p [innerHTML]="this.branding.submitted_text | safeHtml"></p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6 pb-2 pt-2">
          <a id="closeDripsModalButton" class="btn primary-btn drips waves-light uppercase" mdbBtn mdbWavesEffect (click)="closeModal()">{{ this.branding.submitted_button }}</a>
        </div>
      </div>
    </div>
  }
</div>
@if (!showSuccessMessage) {
  <div class="footer">
    <div class="row">
      <div class="col-12">
        <p class="disclaimer" [innerHTML]="this.branding.submitted_disclaimer | safeHtml"></p>
      </div>
    </div>
  </div>
}